// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1hZUS","content":"ManualTimeModal_content__2NHBQ"};